import { Module, Payload } from 'vuex'

export interface IdObject extends Object {
  id: string
}

export interface ModuleState {
  loading: boolean
  storedObjects: { [key: string]: IdObject }
}

export type RootState = any

export const types: {
  mutations: {
    AddObjects: string
    RemoveObjects: string
  }
  actions: {
    DropObject: string
    PullObjects: string
    PushObject: string
  }
} = {
  actions: {
    DropObject: 'dropObject',
    PullObjects: 'pullObjects',
    PushObject: 'pushObject',
  },
  mutations: {
    AddObjects: 'addObjects',
    RemoveObjects: 'removeObjects',
  },
}

export namespace params {
  export namespace actions {
    export interface PullObjects extends Payload {
      where?: IdObject
      setLoading?: boolean
    }

    export interface PushObject extends Payload {
      object: IdObject
      updateInstance: boolean
    }

    export interface DropObject extends Payload {
      object: IdObject
    }
  }

  export namespace mutations {
    export interface AddObjects extends Payload {
      objects: IdObject[]
    }

    export interface RemoveObjects extends Payload {
      objects: Array<IdObject | string>
    }
  }
}
